import { apiClient } from "utils/clients";
import externals from "utils/externals";
import { handleApiAction } from "utils/actions";

export default ({ dispatch, getState }) => next => action => {
    const { type } = action;
    const baseUrl = externals.subscriptionServiceBackend;

    if (type === "MARKETPLACE-CONTEXT:FETCH") {
        const accountId = getState().tenancy?.selectedAccountId;

        return handleApiAction(
            action,
            () => apiClient.get(`${baseUrl}/subscriptions/marketplace-context`, { params: { accountId } })
        ).catch(e => {
            console.error("Error fetching marketplace context", e);
        });
    } else if (type === "MARKETPLACE-CONTEXT:SAVE") {
        const { cloudProvider, serviceName, registrationToken } = action.payload || {};

        return handleApiAction(
            action,
            () => apiClient.post(`${baseUrl}/subscriptions/marketplace-context`, {
                cloudProvider,
                serviceName,
                registrationToken
            })
        )
            .then((result) => {
                // handleApiAction returns response.data directly via dataMapper
                // result = { written: true, userId: "..." } or { skipped: true, reason: "..." }
                // Only fetch context when the backend actually wrote a new row.
                // { skipped: true } means not a standalone CVO subscription — nothing to fetch.
                if (result?.written === true) {
                    dispatch({ type: "MARKETPLACE-CONTEXT:FETCH" });
                }
            })
            .catch(e => {
                console.error("Error saving marketplace context", e);
            });
    } else if (type === "MARKETPLACE-CONTEXT:CLEAR") {
        return handleApiAction(action, () =>
            apiClient.delete(`${baseUrl}/subscriptions/marketplace-context`)
        ).catch(e => {
            console.error("Error clearing marketplace context", e);
        });
    }

    return next(action);
};
